import _ from 'lodash';
import { useEffect } from 'react';
import type { ManuallyPrioritiseTasksContext } from '@scale/genai-compass-shared/cards/manually_prioritise_tasks';

function useManuallyPrioritiseTasksCard(
  context: ManuallyPrioritiseTasksContext,
  updateCardContext: (context: ManuallyPrioritiseTasksContext) => void,
  updateCardCanSubmit: (canSubmit: boolean) => void,
) {
  const setTaskIdColumn = (column: string) => {
    const updatedContext: ManuallyPrioritiseTasksContext = _.assign(_.clone(context), {
      taskIdColumn: column,
    });
    updateCardContext(updatedContext);
  };

  const setPriorityColumn = (column: string) => {
    const updatedContext: ManuallyPrioritiseTasksContext = _.assign(_.clone(context), {
      priorityColumn: column,
    });
    updateCardContext(updatedContext);
  };

  useEffect(() => {
    const canSubmit = !_.isEmpty(context.taskIdColumn) && !_.isEmpty(context.priorityColumn);
    updateCardCanSubmit(canSubmit);
  }, [context.taskIdColumn, context.priorityColumn]);

  return {
    taskIdColumn: context.taskIdColumn,
    setTaskIdColumn,
    priorityColumn: context.priorityColumn,
    setPriorityColumn,
  };
}

export default useManuallyPrioritiseTasksCard;
